// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Y-UU","productName":"Table_productName__2RhiZ"};